"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript = class Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        const targetIds = container.selectTargets(event.subject, Target_1.Target.AllEnemies);
        targetIds.forEach(targetId => container.applyDebuff({
            sequence,
            attackerId: event.subject,
            targetId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.SlowEffectArgs(handler.args.scriptArgs.slowStacks)
        }));
    }
};
Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_GazeOfPetrification_OnTurnStarted")
], Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript);
exports.Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript = Effect_GazeOfPetrification_OnTurnStartedEventHandlerScript;
